import React from 'react';

export const LeadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 7C15 8.65685 13.6569 10 12 10C10.3431 10 9 8.65685 9 7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7ZM17 7C17 9.76142 14.7614 12 12 12C9.23858 12 7 9.76142 7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7ZM11 20C8.23858 20 6 17.7614 6 15H18C18 17.7614 15.7614 20 13 20H11ZM4 15C4 13.8954 4.89543 13 6 13H18C19.1046 13 20 13.8954 20 15C20 18.866 16.866 22 13 22H11C7.13401 22 4 18.866 4 15Z"
      fill="#27B0E0"
    />
  </svg>
);
